import { render } from "./InfoView.vue?vue&type=template&id=55a22e60&scoped=true"
import script from "./InfoView.vue?vue&type=script&lang=js"
export * from "./InfoView.vue?vue&type=script&lang=js"

import "./InfoView.vue?vue&type=style&index=0&id=55a22e60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a22e60"]])

export default __exports__